import {Column, HeaderProps} from 'react-table'
import {ITicket} from '../_model'
import SelectionHeader from '../../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/table-content/SelectionCell'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import TicketActionCell from './TicketActionCell'
import {dateFormat, formatDateAsDayAndTime} from '../../../utils/helperFunction/_helper'

const ticketColumnList = (
  handleSelectTicket: (selectType: string, id: number) => void
): ReadonlyArray<Column<ITicket>> => [
  {
    Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ITicket>>) => (
      <CustomHeader tableProps={props} title='username' className='min-w-100px' />
    ),
    id: 'user_name',
    accessor: 'user_name',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ITicket>>) => (
      <CustomHeader tableProps={props} title='subject' className='min-w-100px' />
    ),
    id: 'subject',
    accessor: 'subject',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ITicket>>) => (
      <CustomHeader tableProps={props} title='status' className='min-w-100px' />
    ),
    id: 'status',
    accessor: 'status',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ITicket>>) => (
      <CustomHeader tableProps={props} title='Assigned to' className='min-w-100px' />
    ),
    id: 'assignedTo',
    // accessor: 'assignedTo',
    Cell: ({...props}) => (
      <>
        {props.data[props.row.index].assignedTo
          ? props.data[props.row.index].assignedTo
          : 'Not Assigned'}
      </>
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ITicket>>) => (
      <CustomHeader tableProps={props} title='Created' className='min-w-100px' />
    ),
    id: 'created_at',
    accessor: 'created_at',
    Cell: ({...props}) => <>{dateFormat(props.data[props.row.index].created_at, true)}</>,
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ITicket>>) => (
      <CustomHeader tableProps={props} title='action' className='min-w-100px text-end' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <TicketActionCell id={props.data[props.row.index].id} selectItem={handleSelectTicket} />
    ),
  },
]

export default ticketColumnList
